/** Sample import files — download from Group Configuration (EGMs + Import Mapping). */

function csvEscape(val) {
  const s = String(val ?? '')
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`
  return s
}

export function downloadTextFile(filename, content, mimeType = 'text/plain;charset=utf-8') {
  const blob = new Blob([content], { type: mimeType })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

const MACHINE_MASTER_ROWS = [
  ['010001', 'SERIAL00001', '0.01', 'SAMPLE GAME TITLE A'],
  ['010002', 'SERIAL00002', '0.01', 'SAMPLE GAME TITLE B'],
  ['010003', 'SERIAL00003', '0.01', 'SAMPLE GAME TITLE C'],
]

/** Machine master list for Group Config → EGMs tab (Excel-friendly CSV with column headers). */
export function downloadMachineMasterTemplate() {
  const lines = [
    '# Machine master list — save as .xlsx in Excel if you prefer. Header row is skipped on import.',
    '# Columns: house_number (5-6 digits), serial_number, denom (e.g. 0.01), game_name',
    'house_number,serial_number,denom,game_name',
    ...MACHINE_MASTER_ROWS.map((row) => row.map(csvEscape).join(',')),
    '',
  ]
  downloadTextFile('machine_master_list_template.csv', `\uFEFF${lines.join('\n')}`, 'text/csv;charset=utf-8')
}

/** Ready-to-import sample (no header row). */
export function downloadMachineMasterSample() {
  const lines = MACHINE_MASTER_ROWS.map((row) => row.map(csvEscape).join(','))
  downloadTextFile('machine_master_list_sample.csv', `\uFEFF${lines.join('\n')}\n`, 'text/csv;charset=utf-8')
}

const PIPE_SAMPLES = {
  meter: {
    filename: 'DimMeter_sample.txt',
    comment: '# RXConnect Meter_* — 15 cols: 0=egm_id, 1=snapshot, 2–10=nine cumulative meters, 11–12=status, 13–14=venue. No bill/ticket cols.',
    line: '1001|2026-03-10 04:15:00.000|218000000|209000000|0|0|1900000|77000000|140000|0|0|M|Yes|Sample Venue|Sample Venue',
  },
  sessions: {
    filename: 'FactPlayerSession_sample.txt',
    comment: '# Pipe-delimited sessions extract — no header. Import Mapping → Sessions.',
    line: '100001|010001|Sample Venue|SV|100|2026-03-10 00:00:00.000|2026-03-10 00:00:00.000|2026-03-10 10:00:00.000|2026-03-10 10:30:00.000|.0000|34.0000|100.0000|.0000|14.0000|33.00|134.0000|50|200|2.5000|2000|1|0|.0000|.0000|.0000|Sample Venue|Sample Venue|Yes|0|0',
  },
  patron: {
    filename: 'DimPatron_sample.txt',
    comment: '# Pipe-delimited DimPatron — no header. Import Mapping → Patron.',
    line: '1000|1001|1980-01-15|Financial|ORDINARY|Sample City|1000001001|JOHN SAMPLE|1980-01-15 00:00:00.000|January|2010-06-01 00:00:00.000|Active|Active|Australia|NSW|2000|SAMPLE CITY|SAMPLE ST|1 SAMPLE ST|member@example.com|0400000000|100.0000||M|Sample Venue|SV|100|1|SiteGroup|Sample Venue|Sample Venue',
  },
  egm: {
    filename: 'DimMachine_sample.txt',
    comment: '# Pipe-delimited DimMachine (65 cols) — no header. Import Mapping → EGM Registry.',
    line: '100001|2024-01-01 00:00:00.000|2024-06-01 00:00:00.000|01|01|01|010001|Aristocrat||SERIALABC01|SAMPLE GAME TITLE|iBoard|Active|EGM|.0100|400|10.00|90.00|GAMEID|N|.00|Y|0|N|Y|1|.0000|10.00|XSeries|Y|Y|1.0000|0|B|EGM|Sample Venue|SV|100|1|SiteGroup|1.AA001|01|Main Area||Sample Venue||On||||||||||||||||Sample Venue|Sample Venue',
  },
  slot_analysis: {
    filename: 'FactSlotAnalysisDaily_sample.txt',
    comment: '# Pipe-delimited FactSlotAnalysisDaily — 33 cols, no header. Import Mapping → Slot analysis.',
    line: '2026-03-10|1001|5000.00|4900.00|0.00|500|1200.00|3000.00|5000.00|3800.00|0.00|0.00|1200.00|0.00|8|2500.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|Yes|Sample Venue|Sample Venue|0.00|0.00|0.00|0.00|0.00|0.00',
  },
}

/** Sample pipe-delimited file for Import Mapping import types. */
export function downloadImportMappingSample(importType) {
  const sample = PIPE_SAMPLES[importType]
  if (!sample) return
  const body = `${sample.comment}\n${sample.line}\n`
  downloadTextFile(sample.filename, body)
}

export function importMappingSampleLabel(importType) {
  const labels = {
    meter: 'DimMeter sample (.txt)',
    sessions: 'Sessions sample (.txt)',
    patron: 'DimPatron sample (.txt)',
    egm: 'DimMachine sample (.txt)',
    slot_analysis: 'FactSlotAnalysisDaily sample (.txt)',
  }
  return labels[importType] || 'Sample file'
}
